import axios from "axios";

const {
  /** The base URL for the API. */
  REACT_APP_API_URL,
} = process.env;

/** Axios instance to use for api requests. */
export default axios.create({
  baseURL: REACT_APP_API_URL,
});
